import React from 'react'

function Footer() {
  return (
    <div className='absolute bottom-1 left-0 right-0 mx-auto w-fit '>
      <div className="text-3xs font-normal text-headPrimary">Copyright © SAYCRYPT.com &nbsp;&nbsp; All Rights Reserved.</div>
    </div>
  )
}

export default Footer